module.exports = __webpack_public_path__ + "img/desk_banner.71767149.png";